<motif-modal-title>
    <div class="headerSection">
        <motif-icon class="motif-modal-header-close-icon" [iconFunction]="infoIcon"></motif-icon>
        <h2>{{ data.title | translate }}</h2>
    </div>
</motif-modal-title>
<motif-modal-content>
    <div class="description" [innerHTML]="translatedMessage"></div>
</motif-modal-content>
<hr class="exp-line" />
<motif-modal-actions>
    <button *ngIf="data.show" motifButton color="primary" [motif-modal-close]="true" aria-label="Install">
        {{data.continueButtonText|translate}}
    </button>
    <button *ngIf="!data.show" motifButton color="primary" [motif-modal-close]="false" aria-label="Install">
        {{data.okButtonText|translate}}
    </button>
</motif-modal-actions>